import { createContext, type ReactNode, useContext, useState } from 'react';
import { patternTheme, type Theme } from '../styles/globalTheme';

interface ThemeContextType {
	theme: Theme;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
	children: ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
	const [theme] = useState<Theme>(patternTheme);

	return <ThemeContext.Provider value={{ theme }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
	const context = useContext(ThemeContext);
	if (!context) {
		throw new Error('useTheme deve ser usado dentro de um ThemeProvider');
	}
	return context;
};
